export const MAX_TOPICS_PER_POST = 5;
export const MAX_TOPICS_PER_SPACE = 20;
